// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"507":"023df0f4","596":"bcd87ab6","711":"ee89359c","741":"189ecd43","789":"bd36027d"}[chunkId] + ".chunk.js";
};